import StatePage from '../../../components/StatePage/StatePage';

const ResetPasswordError = () => <StatePage icon="alert" eyebrow="Recuperación de contraseña" title="No pudimos verificar el enlace" text="El enlace puede haber vencido o el servicio no está disponible. Solicita uno nuevo e inténtalo nuevamente." actionLabel="Solicitar otro enlace" actionTo="/forgotpassword" tone="error" />;

export default ResetPasswordError;
